module.exports = __webpack_public_path__ + "img/add.29cd878b.svg";